import { render } from "./ShowStartListDialog.vue?vue&type=template&id=55bd5275&scoped=true"
import script from "./ShowStartListDialog.vue?vue&type=script&lang=js"
export * from "./ShowStartListDialog.vue?vue&type=script&lang=js"

import "./ShowStartListDialog.vue?vue&type=style&index=0&id=55bd5275&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bd5275"]])

export default __exports__